import { render, staticRenderFns } from "./wtTagsListItem.component.vue?vue&type=template&id=74ad64ae&"
import script from "./wtTagsListItem.component.vue?vue&type=script&lang=js&"
export * from "./wtTagsListItem.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports